import React, { FC, useState } from 'react';
import { Cancel } from '@mui/icons-material';
import { Dialog, IconButton, Table, TableCell, TableRow } from '@mui/material';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import API from 'api/API';
import { FastAPIError } from 'api/ErrorHandler';
import Button from 'components/Button';
import InputField from 'components/InputField';
// import PageSpinner from 'components/PageSpinner/PageSpinner';
import { useLanguage } from 'context/AppContext';
import * as Styles from './AddSerialNumberModal.styles';

interface EditDraftModalProps {
  open: boolean;
  close: () => void;
  setUUID: string | null;
  setSerialNumberBelongsToDifferentSetModalOpen: (errorMessage: string, serialNumber: string) => void;
}

const AddSerialNumberModal: FC<EditDraftModalProps> = ({
  open,
  close,
  setUUID,
  setSerialNumberBelongsToDifferentSetModalOpen,
}) => {
  const [language] = useLanguage();
  // const [loadingLocations, setLoadingLocations] = useState<boolean>(true);
  // const [locations, setLocations] = useState<ReactNode[]>([]);
  const [serialNumber, setSerialNumber] = useState('');
  // const user = useUser();

  const handleConfirm = async (): Promise<void> => {
    try {
      await API.UssEndpoint.addSerialNumber({ set_code: setUUID || '', new_uss: serialNumber, move_uss: false });
      toast.success(language.ManageSerialNumbers.Modal.success);
    } catch (error) {
      const fastError = error as AxiosError<FastAPIError>;
      const errorMessage = fastError?.response?.data.detail;

      if (errorMessage?.includes('already belongs to the set ')) {
        await setSerialNumberBelongsToDifferentSetModalOpen(errorMessage || 'unknown error', serialNumber);
      } else {
        API.errorHandler(error);
      }
    }
    setSerialNumber('');
    close();
  };

  // const generateMenuItem = (id: string, name: string): ReactNode => (
  //   <MenuItem value={id} key={id}>
  //     {name}
  //   </MenuItem>
  // );

  // useEffect(() => {
  //   if (user.isAuthenticated && user.org_id) {
  //     Promise.resolve(API.userManagement.listLocations(user.org_id))
  //       .then(locations => {
  //         setLocations(locations.map(({ location_id, name }) => generateMenuItem(location_id, name)));
  //       })
  //       .finally(() => setLoadingLocations(false));
  //   }
  // }, [user]);

  return (
    <Dialog open={open} onClose={close} maxWidth={'lg'} fullWidth={false}>
      {/* {loadingLocations && <PageSpinner />} */}
      <Styles.Container>
        <IconButton sx={{ position: 'absolute', top: '1rem', right: '1rem' }} onClick={close}>
          <Cancel />
        </IconButton>
        <h2 style={{ textAlign: 'left', paddingLeft: '15px' }}>{language.ManageSerialNumbers.Modal.title}</h2>
        <Table>
          <TableRow>
            <TableCell>
              <Styles.Message>{language.ManageSerialNumbers.Modal.enterUniqueSerialNumber}</Styles.Message>
            </TableCell>
            <TableCell>
              <InputField
                type="text"
                variant="outlined"
                fullWidth
                value={serialNumber}
                onChange={e => setSerialNumber(e.target.value)}
              />
            </TableCell>
          </TableRow>
          {/* TODO: Add in the ability to select region later - for the MVP this is not included */}
          {/* <TableRow>
            <TableCell>
              <Styles.Message>{language.ManageSerialNumbers.Modal.location}</Styles.Message>
            </TableCell>
            <TableCell>
              <DropDown
                onChange={event => setLocation(event.target.value as string)}
                defaultValue={'none'}
                value={location ?? 'none'}
              >
                {locations}
              </DropDown>
            </TableCell>
          </TableRow> */}
        </Table>

        <Button onClick={handleConfirm} style={{ position: 'absolute', bottom: '1rem', right: '1rem' }}>
          {language.ManageSerialNumbers.Modal.submit}
        </Button>
        <Button onClick={() => close()} style={{ position: 'absolute', bottom: '1rem', left: '1rem' }}>
          {language.ManageSerialNumbers.Modal.cancel}
        </Button>
      </Styles.Container>
    </Dialog>
  );
};

export default AddSerialNumberModal;
